import React, {Component} from "react";
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import InputMaterial from "../shared/InputMaterial";
import Pattern, {match} from "../../utils/Pattern";
import Loading from "../shared/Loading";
import {countryList, registerAccount, uploadProfilePhoto} from "../../utils/API"
import {history} from "../../history/History";
import {set} from "../../redux/Action";
import MiniSelectbox from "../shared/MiniSelectbox";
import Selectbox from "../utils/Selectbox";
import UploadImage from "../shared/UploadImage";
import logo from "../../images/logo-white.png";

// const stripePromise = loadStripe('pk_live_4C1NJaevrhgUgFm14yyTLlzS');

export const registerTypes = [{id: 0, title: 'Student'}, {id: 1, title: 'Tutor'}, {id: 2, title: 'Both'}];
export const educationLevels = [{id: 0, title: 'High School'},
    {id: 1, title: 'Bachelor\'s Degree'},
    {id: 2, title: 'Master\'s Degree'},
    {id: 3, title: 'Ph.D'}];
export const idTypes = [{id: 0, title: 'Student ID'},
    {id: 1, title: 'Driver\'s License'},
    {id: 2, title: 'Other ID'}];

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            usernameValid: undefined,
            email: '',
            emailValid: undefined,
            password: '',
            repeatPassword: '',
            registerApi: false,
            registerType: registerTypes[0],
            countryList: [],
            country: undefined,
            educationLevel: undefined,
            profilePhoto: undefined,
            idType: undefined,
            idPhoto: undefined,
        }
    }


    componentDidMount() {
        countryList((res) => {
            this.setState({countryList: res})
        })
        if (this.props.sendCode) {
            if (this.props.sendCode.type === 'forgotPassword')
                this.props.dispatch(set(Objects.sendCode, undefined))
            else
                this.setState({
                    username: this.props.sendCode.username,
                    usernameValid: match(Pattern.USERNAME, this.props.sendCode.username),
                    email: this.props.sendCode.email,
                    emailValid: match(Pattern.EMAIL, this.props.sendCode.email),
                    password: this.props.sendCode.password,
                    repeatPassword: this.props.sendCode.repeatPassword,
                    registerType: this.props.sendCode.registerType,
                    country: this.props.sendCode.country,
                    educationLevel: this.props.sendCode.educationLevel,
                    profilePhoto: this.props.sendCode.profilePhoto,
                    idType: this.props.sendCode.idType,
                    idPhoto: this.props.sendCode.idPhoto,
                })
        }
    }


    setEmail(evt) {
        evt.preventDefault();
        if (evt.target.value.length >= 64)
            return
        this.setState({
            email: evt.target.value,
            emailValid: match(Pattern.EMAIL, evt.target.value),
        })
    }

    setUsername(evt) {
        evt.preventDefault();
        if (evt.target.value.length >= 48)
            return
        this.setState({
            username: evt.target.value,
            usernameValid: match(Pattern.USERNAME, evt.target.value),
        })
    }

    setPassword(evt) {
        evt.preventDefault();
        if (evt.target.value.length >= 32)
            return
        this.setState({
            password: evt.target.value,
        })
    }

    setRepeatPassword(evt) {
        evt.preventDefault();
        if (evt.target.value.length >= 32)
            return
        this.setState({
            repeatPassword: evt.target.value,
        })
    }

    create = async (ctx) => {
        if (!match(Pattern.EMAIL, this.state.email) ||
            !match(Pattern.USERNAME, this.state.username) ||
            this.state.password.length < 4 ||
            this.state.password !== this.state.repeatPassword ||
            !this.state.country ||
            !this.state.educationLevel ||
            !this.state.profilePhoto) {
            return
        }
        if ((this.state.registerType.id === 1 || this.state.registerType.id === 2) && (
            !this.state.idType ||
            !this.state.idPhoto))
            return;
        // let pm;
        // if (this.state.registerType.id === 0) {
        //     const {elements, stripe} = ctx;
        //     const cardElement = elements.getElement(CardElement);
        //
        //     if (!stripe || !elements) {
        //         show('Payment method is not available')
        //         return;
        //     }
        //     this.setState({registerApi: true})
        //     const {error, paymentMethod} = await stripe.createPaymentMethod({
        //         type: 'card',
        //         card: cardElement,
        //     });
        //     if (error) {
        //         this.setState({registerApi: false})
        //         show(error.message)
        //         return
        //     } else {
        //         pm = paymentMethod;
        //     }
        // }

        this.setState({registerApi: true})
        let param = {
            username: this.state.username,
            email: this.state.email,
            password: this.state.password,
            educationLevel: this.state.educationLevel.id,
            country: this.state.country.id,
            profilePhotoUrl: this.state.profilePhoto,
            tutor: this.state.registerType.id === 1 || this.state.registerType.id === 2,
        }
        if (param.tutor)
            param = {
                ...param,
                idType: this.state.idType.id,
                idPhotoUrl: this.state.idPhoto,
            }
        // else
        //     param = {
        //         ...param,
        //         pmToken: pm.id
        //     }
        registerAccount(param, (res) => {
            this.props.dispatch(set(Objects.sendCode, {
                type: 'register',
                username: this.state.username,
                email: this.state.email,
                password: this.state.password,
                educationLevel: this.state.educationLevel.id,
                country: this.state.country.id,
                profilePhotoUrl: this.state.profilePhoto,
                tutor: param.tutor,
                idType: this.state.idType,
                idPhotoUrl: this.state.idPhoto,
            }))
            this.setState({registerApi: false})
            history.push("/hom/send-code")
        }, () => {
            this.setState({registerApi: false})
        })
    }

    render() {
        return (
            <div className="contain-app">
                <div className="logo">
                    <img alt="logo" src={logo}/>
                </div>
                <div className="body-login">
                    <div>
                        <h4>Register Form</h4>
                        <span className="d-block mt-5 mb-2">Choose register type</span>

                        <MiniSelectbox
                            items={registerTypes}
                            value={this.state.registerType}
                            keyItem='title'
                            onChange={(item) => {
                                this.setState({registerType: item})
                            }}
                        />
                        <h5 className="bold mt-5">General Information</h5>
                        <InputMaterial id="email"
                                       type="email"
                                       valid={this.state.emailValid}
                                       value={this.state.email}
                                       title="Email"
                                       wrongMsg={"Email format incorrect"}
                                       onChange={(evt) => this.setEmail(evt)}
                        />
                        <InputMaterial id="Username"
                                       type="text"
                                       valid={this.state.usernameValid}
                                       value={this.state.username}
                                       title="Username"
                                       wrongMsg={"Username format incorrect"}
                                       onChange={(evt) => this.setUsername(evt)}
                        />
                        <InputMaterial id="password"
                                       type="password"
                                       valid={this.state.password.length === 0 ? undefined : (this.state.password.length > 3)}
                                       value={this.state.password}
                                       title="password"
                                       wrongMsg={"Password must be at least 4 character"}
                                       onChange={(evt) => this.setPassword(evt)}
                        />
                        <InputMaterial id="repeatPassword"
                                       type="password"
                                       valid={this.state.password === this.state.repeatPassword}
                                       value={this.state.repeatPassword}
                                       title="Confirm password"
                                       wrongMsg={"The password does not match the repetition"}
                                       onChange={(evt) => this.setRepeatPassword(evt)}
                        />
                        <Selectbox items={this.state.countryList}
                                   className="select-tutorfest mb-3"
                                   activeClassName="active"
                                   value={this.state.country}
                                   defaultTitle="Choose country"
                                   onSelect={(item) => this.setState({country: item})}
                        />
                        <Selectbox items={educationLevels}
                                   className="select-tutorfest mb-3"
                                   activeClassName="active"
                                   value={this.state.educationLevel}
                                   defaultTitle="Choose education level"
                                   onSelect={(item) => this.setState({educationLevel: item})}
                        />
                        <UploadImage id="profile"
                                     withCrop
                                     aspect={1}
                                     initialWidth={40}
                                     onComplete={(image) => {
                                         uploadProfilePhoto(image, (res) => {
                                             this.setState({profilePhoto: res.data.data})
                                         })
                                     }}
                        >
                            <div className="upload-image-photo">
                                <span>{this.state.profilePhoto ? 'Profile photo Uploaded' : 'Upload profile photo'}</span>
                                {this.state.profilePhoto && <i className="icon-checkmark-outline ml-3"/>}
                            </div>
                        </UploadImage>
                        {(this.state.registerType.id === 1 || this.state.registerType.id === 2) && <Selectbox items={idTypes}
                                                                        className="select-tutorfest mb-3"
                                                                        activeClassName="active"
                                                                        value={this.state.idType}
                                                                        defaultTitle="Choose ID type"
                                                                        onSelect={(item) => this.setState({idType: item})}
                        />}

                        {(this.state.registerType.id === 1 || this.state.registerType.id === 2) && <UploadImage id="idType"
                                                                          onComplete={(image) => {
                                                                              uploadProfilePhoto(image, (res) => {
                                                                                  this.setState({idPhoto: res.data.data})
                                                                              })
                                                                          }}
                        >
                            <div className="upload-image-photo">
                                <span>{this.state.idPhoto ? 'ID photo Uploaded' : 'Upload ID photo'}</span>
                                {this.state.idPhoto && <i className="icon-checkmark-outline ml-3"/>}
                            </div>
                        </UploadImage>}

                        {/*{this.state.registerType.id === 0 && <div>*/}
                        {/*    <h5 className="bold mt-5">Payment Information</h5>*/}
                        {/*    <Elements stripe={stripePromise}>*/}
                        {/*        <ElementsConsumer>*/}
                        {/*            {(ctx) => <div>*/}
                        {/*                <CardElement id="" options={{*/}
                        {/*                    style: {*/}
                        {/*                        base: {*/}
                        {/*                            backgroundColor: '#000',*/}
                        {/*                            padding: '10px',*/}
                        {/*                            color: '#fff',*/}
                        {/*                            fontSize: "18px",*/}
                        {/*                            "::placeholder": {*/}
                        {/*                                color: "#fff"*/}
                        {/*                            }*/}
                        {/*                        }*/}
                        {/*                    }*/}
                        {/*                }}/>*/}
                        {/*                <div className="mt-3" style={{*/}
                        {/*                    borderTop: '1px solid #ced4da',*/}
                        {/*                }}>*/}
                        {/*                    <button*/}
                        {/*                        onClick={() => this.create(ctx)}*/}
                        {/*                        disabled={this.state.registerApi}*/}
                        {/*                        className="mt-3 waves-effect waves-light btn-large white w-100 no-uppercase bold">*/}
                        {/*                        <Loading show={this.state.registerApi}>*/}
                        {/*                            <span>Confirm</span>*/}
                        {/*                        </Loading>*/}
                        {/*                    </button>*/}
                        {/*                </div>*/}
                        {/*            </div>}*/}
                        {/*        </ElementsConsumer>*/}
                        {/*    </Elements>*/}
                        {/*</div>}*/}
                        {/*{this.state.registerType.id === 1 && */}
                        <div className="mt-3">
                            <button className="waves-effect waves-light btn-large white w-100 no-uppercase bold"
                                    disabled={this.state.registerApi} onClick={this.create}>
                                <Loading show={this.state.registerApi}>
                                    <span>Confirm</span>
                                </Loading>
                            </button>
                        </div>
                        {/*}*/}
                        <div className="mt-4 mb-5">
                            <span className="grey-text">Back to login page</span>
                            <button className="white-text ml-1" onClick={() => history.goBack()}>Click Here</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        sendCode: state.param[Objects.sendCode],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)
